var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-panel map-header-panel title-text"},[_c('b-link',{staticClass:"hidden-link",attrs:{"to":"/"}},[_vm._v(" Сервис для подбора здания и генерации квартирографии ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }